// RegisterInterestForm.styles.ts
import { alpha } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles((theme) => ({
  dialogTitle: {
    color: '#000',
    fontFamily: 'Inter, sans-serif',
    fontSize: 32,
    fontWeight: 500,
    lineHeight: 1.1,
  },

  leftCard: {
    boxShadow: 'none',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },

  rightCard: {
    boxShadow: 'none',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },

  cardContentGrow: {
    padding: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },

  borderPanel: {
    border: '1px solid',
    borderColor: theme.palette.divider,
    borderRadius: 6,
    backgroundColor: theme.palette.background.paper,
  },

  labelXs: {
    fontSize: 12,
    marginBottom: 4,
    fontWeight: 500,
    color: theme.palette.accent.sky,
  },

  valueXs: {
    fontSize: 14,
    color: theme.palette.text.primary,
    fontWeight: 400,
    paddingTop: theme.spacing(1),
  },

  inputShell: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    marginTop: theme.spacing(3),
    width: '100%',
    height: 54,
    paddingInline: theme.spacing(2),
    borderRadius: 6,
    border: '1px solid #98B6BE',
    background: '#FFF',
    minWidth: 0,
    '&:focus-within': {
      borderColor: '#00B6B0',
    },
  },

  textFieldRoot: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    '& .MuiInputBase-root': {
      flex: 1,
      minWidth: 0,
      height: '100%',
      display: 'flex',
      alignItems: 'center',
    },
    '& .MuiInputBase-input': {
      flex: 1,
      minWidth: 0,
      width: '100%',
      padding: 0,
      fontSize: 14,
    },
    '& .MuiInputLabel-root': {
      color: '#00B6B0',
      fontSize: 12,
      fontWeight: 500,
      transform: 'translate(12px, 18px) scale(1)',
    },
    '& .MuiInputLabel-shrink': {
      transform: 'translate(12px, -8px) scale(0.85)',
    },
  },

  commentsShell: {
    display: 'flex',
    width: '100%',
    minHeight: 120,
    paddingInline: theme.spacing(2),
    paddingBlock: theme.spacing(1),
    borderRadius: 6,
    border: '1px solid #98B6B0',
    background: '#FFF',
    '&:focus-within': { borderColor: '#00B6B0' },
  },

  commentsFieldRoot: {
    flex: 1,
    '& .MuiInputBase-root': {
      flex: 1,
      alignItems: 'flex-start',
      height: '100%',
    },
    '& .MuiInputBase-input': {
      padding: 0,
      fontSize: 14,
    },
    '& .MuiInputLabel-root': {
      color: '#00B6B0',
      fontSize: 12,
      fontWeight: 500,
      transform: 'translate(12px, 18px) scale(1)',
    },
    '& .MuiInputLabel-shrink': {
      transform: 'translate(12px, -8px) scale(0.85)',
    },
  },

  applyBtn: {
    borderRadius: 999,
    paddingInline: theme.spacing(3),
    paddingBlock: theme.spacing(1),
  },

  outlinedTight: {
    '& .MuiOutlinedInput-root': {
      borderRadius: theme.shape.borderRadius * 1.5,
      '& fieldset': { borderColor: theme.palette.divider },
      '&:hover fieldset': {
        borderColor: alpha(theme.palette.text.primary, 0.6),
      },
    },
  },
}))
